module.exports = __webpack_public_path__ + "img/icon_logo_tc@3x.db7ae774.png";